<template>
  <div class="tab_header">
    <div class="th_body">
      <div class="th_content">
        <p>이용약관 동의</p>
      </div>
      <div class="th_content">
        <p>회원정보 입력</p>
      </div>
    </div>
    <div class="trackingProgress">
      <div class="progress" :class="{pos : pos}"></div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    transDataSet: {
      pos: {
        type: String
      },
      chapter: {
        type: String
      }
    }
  },
  data () {
    return {
      pos: this.transDataSet.pos,
      chapter: this.transDataSet.chapter
    }
  },
  mounted () {
    this.findChapter()
  },
  methods: {
    findChapter () {
      if (this.chapter === 1) {
        document.querySelector('.th_body').childNodes[0].querySelector('p').classList.add('active')
      }
      if (this.chapter === 2) {
        document.querySelector('.th_body').childNodes[1].querySelector('p').classList.add('active')
      }
    }
  }
}
</script>
<style lang="scss">
</style>
